<!--
 * @Description: 
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <table-render
    ref="tableRender"
    :propData="{ query: { payPassagewayCode } }"
    :config="config"
  />
</template>

<script>
import tableRender from '@/components/tableRender';
import { main } from './config';
export default {
  props: {
    payPassagewayCode: {
      type: String
    }
  },
  data() {
    return {
      config: main
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
